import { render, staticRenderFns } from "./ecollection.vue?vue&type=template&id=f9d30206&"
import script from "./ecollection.vue?vue&type=script&lang=js&"
export * from "./ecollection.vue?vue&type=script&lang=js&"
import style0 from "./ecollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports